import { render, staticRenderFns } from "./EBookCompanies.vue?vue&type=template&id=1638579f&"
import script from "./EBookCompanies.vue?vue&type=script&lang=js&"
export * from "./EBookCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports